module.exports = __webpack_public_path__ + "static/media/trash_bin.1b53567f.svg";